/**
 * Google Identity Services (GIS) OAuth Plugin for Vue.js
 * Updated to use the new Google Identity Services library
 * since the old gapi.auth2 library is deprecated
 */

var googleAuth = (function () {
    function installClient() {
        var apiUrl = 'https://accounts.google.com/gsi/client'
        return new Promise((resolve, reject) => {
            var script = document.createElement('script')
            script.src = apiUrl
            script.async = true
            script.defer = true
            script.onload = function () {
                setTimeout(function () {
                    resolve()
                }, 500)
            }
            script.onerror = function () {
                reject(new Error('Failed to load Google Identity Services'))
            }
            document.getElementsByTagName('head')[0].appendChild(script)
        })
    }

    function Auth() {
        if (!(this instanceof Auth))
            return new Auth()
        
        this.isInit = false
        this.isAuthorized = false
        this.clientId = null
        this.tokenClient = null
        this.accessToken = null
        this.userProfile = null

        this.isLoaded = function() {
            console.warn('isLoaded() will be deprecated. You can use "this.$gAuth.isInit"')
            return this.isInit
        }

        this.load = (config, prompt) => {
            this.clientId = config.clientId
            
            return installClient()
                .then(() => {
                    this.isInit = true
                    console.log('Google Identity Services loaded successfully')
                })
                .catch((error) => {
                    console.error('Error loading Google Identity Services:', error)
                    this.isInit = false
                })
        }

        this.signIn = (successCallback, errorCallback) => {
            return new Promise((resolve, reject) => {
                if (!this.isInit) {
                    const error = new Error('Google Identity Services not initialized')
                    if (typeof errorCallback === 'function') errorCallback(error)
                    reject(error)
                    return
                }

                try {
                    // Initialize the token client for OAuth 2.0
                    this.tokenClient = window.google.accounts.oauth2.initTokenClient({
                        client_id: this.clientId,
                        scope: 'profile email',
                        callback: async (tokenResponse) => {
                            if (tokenResponse.error) {
                                const error = new Error(tokenResponse.error)
                                if (typeof errorCallback === 'function') errorCallback(error)
                                reject(error)
                                return
                            }

                            this.accessToken = tokenResponse.access_token
                            this.isAuthorized = true

                            // Fetch user info using the access token
                            try {
                                const userInfoResponse = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
                                    headers: {
                                        'Authorization': `Bearer ${this.accessToken}`
                                    }
                                })
                                
                                const userInfo = await userInfoResponse.json()
                                
                                // Create a user profile object compatible with the old API
                                this.userProfile = {
                                    getId: () => userInfo.sub,
                                    getName: () => userInfo.name,
                                    getGivenName: () => userInfo.given_name,
                                    getFamilyName: () => userInfo.family_name,
                                    getImageUrl: () => userInfo.picture,
                                    getEmail: () => userInfo.email
                                }

                                // Return an object compatible with old GoogleUser API
                                const googleUser = {
                                    getId: () => userInfo.sub,
                                    getBasicProfile: () => this.userProfile,
                                    getAuthResponse: () => ({
                                        access_token: this.accessToken,
                                        id_token: tokenResponse.id_token
                                    })
                                }
                                
                                if (typeof successCallback === 'function') successCallback(googleUser)
                                resolve(googleUser)
                            } catch (error) {
                                if (typeof errorCallback === 'function') errorCallback(error)
                                reject(error)
                            }
                        },
                        error_callback: (error) => {
                            console.error('Google Sign-In error:', error)
                            if (typeof errorCallback === 'function') errorCallback(error)
                            reject(error)
                        }
                    })

                    // Request the access token (this will show the Google sign-in popup)
                    this.tokenClient.requestAccessToken({ prompt: 'select_account' })
                } catch (error) {
                    console.error('Error during Google Sign-In:', error)
                    if (typeof errorCallback === 'function') errorCallback(error)
                    reject(error)
                }
            })
        }

        this.getAuthCode = (successCallback, errorCallback) => {
            return new Promise((resolve, reject) => {
                // This method is not directly supported in the new API
                // but we can return the access token as a workaround
                if (!this.accessToken) {
                    const error = new Error('No auth code available. Please sign in first.')
                    if (typeof errorCallback === 'function') errorCallback(error)
                    reject(error)
                    return
                }
                if (typeof successCallback === 'function') successCallback(this.accessToken)
                resolve(this.accessToken)
            })
        }

        this.signOut = (successCallback, errorCallback) => {
            return new Promise((resolve, reject) => {
                try {
                    if (this.accessToken && window.google && window.google.accounts) {
                        window.google.accounts.oauth2.revoke(this.accessToken, () => {
                            this.accessToken = null
                            this.isAuthorized = false
                            this.userProfile = null
                            if (typeof successCallback === 'function') successCallback()
                            resolve(true)
                        })
                    } else {
                        this.accessToken = null
                        this.isAuthorized = false
                        this.userProfile = null
                        if (typeof successCallback === 'function') successCallback()
                        resolve(true)
                    }
                } catch (error) {
                    if (typeof errorCallback === 'function') errorCallback(error)
                    reject(error)
                }
            })
        }
    }

    return new Auth()
})()

function installGoogleAuthPlugin(Vue, options) {
    // Set config
    let GoogleAuthConfig = null
    let GoogleAuthDefaultConfig = { scope: 'profile email', discoveryDocs: [] }
    let prompt = 'select_account'
    
    if (typeof options === 'object') {
        GoogleAuthConfig = Object.assign(GoogleAuthDefaultConfig, options)
        if (options.scope) GoogleAuthConfig.scope = options.scope
        if (options.prompt) prompt = options.prompt
        if (!options.clientId) {
            console.warn('clientId is required')
        }
    } else {
        console.warn('invalid option type. Object type accepted only')
    }

    // Install Vue plugin
    Vue.gAuth = googleAuth
    Object.defineProperties(Vue.prototype, {
        $gAuth: {
            get: function () {
                return Vue.gAuth
            }
        }
    })
    
    Vue.gAuth.load(GoogleAuthConfig, prompt)
}

export default installGoogleAuthPlugin